import { useHtmlDir } from '@aboutyou/legacy-shared/src/LegacyWebCoreConfigContext'
import { TrackingPageTypeWithoutId } from '@aboutyou/legacy-tracking-sdk'
import Headline from 'components/PageHeadline'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { PageTrackingContextProvider } from 'helpers/tracking/PageTrackingContext'
import { useTrackingPageUrl } from 'helpers/tracking/hooks/useTrackingPageUrl'
import React, { FC } from 'react'
import { Element as ScrollElement } from 'react-scroll'
import styled, { css } from 'styled-components'
import { black } from 'uiComponents/constants/colors'
import { fsXS } from 'uiComponents/constants/typography'
import DocumentHead from './components/DocumentHead'
import { StickyOutfitNavigation } from './components/OutfitNavigation'
import OutfitTileGrid from './components/OutfitTileGrid'

const Container = styled.div`
  min-height: 100px;
`

const customHeadlineText = css`
  font-size: ${fsXS}px;
  text-align: center;
  color: ${black};
  margin-bottom: 30px;
`

const OutfitOverviewPage: FC = () => {
  const { t } = useTranslation()

  const stickyContainerRef: React.RefObject<any> = React.createRef()
  const isRTL = useHtmlDir() === 'rtl'

  return (
    <Container>
      <DocumentHead />
      <div className="container-fluid container-fluid-1920">
        <Headline
          title={t('Outfits Inspiration')}
          text={t('Entdecke neue Outfits für alle Anlässe')}
          customStyles={{ text: customHeadlineText }}
        />
      </div>
      <ScrollElement data-testid="OutfitsSection" name="outfits">
        <div ref={stickyContainerRef}>
          <StickyOutfitNavigation container={stickyContainerRef} />
          <Container className="container">
            <OutfitTileGrid isRTL={isRTL} />
          </Container>
        </div>
      </ScrollElement>
    </Container>
  )
}

const TrackedOutfitOverviewPage: FC = () => {
  const { path, search } = useTrackingPageUrl()

  return (
    <PageTrackingContextProvider
      path={path}
      search={search}
      type={TrackingPageTypeWithoutId.OutfitOverview}
    >
      <OutfitOverviewPage />
    </PageTrackingContextProvider>
  )
}

export default TrackedOutfitOverviewPage
